import { isMobileOrTablet } from './src-utils-mobile-utils.js';

const handleFilters = () => {
  const customButton = document.getElementById("caHelpButton");
  if (isMobileOrTablet() && customButton != null) {
    const mobileFilterButton = document.getElementById("mobile-button-filter");
    const closeButton = document.getElementById("mobile-filter-header-close-x");
    const resultsButton = document.getElementById("mobile-filter-footer-close-button");
    const showCustomButton = (isVisible) => {
      customButton.style.visibility = isVisible ? "visible" : "hidden";
    };
    mobileFilterButton?.addEventListener("click", () => showCustomButton(false));
    closeButton?.addEventListener("click", () => showCustomButton(true));
    resultsButton?.addEventListener("click", () => showCustomButton(true));
  }
};

export { handleFilters };
//# sourceMappingURL=src-utils-chat-discovery-page.js.map
